<template>
  <div id="footer">
    <Decorate />
    <FixButton />
    <!-- <div class="times">
      <span>{{$t('例行維護時間')}}：{{$t('每週四')}}</span>
      <el-divider class="hidden-md-and-down" direction="vertical"></el-divider>
      <br class="hidden-md-and-up" />
      <span>{{$t('客服服務時間')}}：{{$t('週一至週五')}}</span>
      <br class="hidden-md-and-up" />
      <el-divider class="hidden-md-and-down" direction="vertical"></el-divider>
      <span>{{$t('客服信箱')}}：pangtwamhcs@panggame.com</span>
    </div> -->
    <div class="logo">
      <!-- <span
        ><img src="@/assets/img/footer/img_foot_copy.png" alt="" srcset=""
      /></span> -->
    </div>
    <div class="copyright">
      <span
        ><img src="@/assets/img/footer/omgo_pangsky_foot.png" alt="" srcset=""
      /></span>
      <span>
        <br />ชื่อบริษัท: Pangsky Co. Ltd.ที่อยู่บริษัท: 25, Nonhyeon-ro 80-gil, Gangnam-gu, Seoul, Republic of Korea
        <br />อีเมล: panggamehelp@panggame.com <br />Copyright © PangSky Corp. All rights
        reserved.
      </span>
    </div>
  </div>
</template>

<script>
import FixButton from "../views/Reservation/components/FixButton";
export default {
  components: {
    FixButton,
  },
  data() {
    return {
      fullWidth: 0,
    };
  },
  methods: {
    handleResize() {
      this.fullWidth = document.documentElement.clientWidth;
    },
  },
  mounted() {
    this.handleResize();
  },
  created() {
    window.addEventListener("resize", this.handleResize);
  },
  beforeDestroy: function () {
    window.removeEventListener("resize", this.handleResize);
  },
};
</script>

<style lang="scss">

#footer {
  background-color: #000;
  color: #fff;
  padding: 100px 0;
  width: 100%;
  text-align: center;
  position: relative;
  .fixbutton{
    position: static;
    max-width: 20rem;
    margin: 4rem auto;
    img{
      width: 100%;
      height: auto;
    }
  }
  .times {
    display: flex;
    justify-content: center;
    font-size: 14px;
    text-align: center;
    @media only screen and (max-width: 900px) {
      font-size: 14px;
      padding: 0 60px;
      display: block;
    }
  }
  .logo {
    margin: 20px;
    @media only screen and (max-width: 900px) {
      margin: 20px;
    }
    span {
      img {
        display: inline-block;
        height: auto;
        width: 40%;
        @media only screen and (max-width: 900px) {
          width: 90%;
        }
      }
    }
  }
  .copyright {
    color: #7f7e7e;
    font-size: 14px;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    @media only screen and (max-width: 900px) {
      font-size: 14px;
    }
    span {
      text-align: left;
      &:nth-child(2) {
        margin-top: -15px;
        margin-left: 20px;
        margin-right: 20px;
        @media only screen and (max-width: 900px) {
          margin-top: 15px;
          margin-left: 20px;
          margin-right: 20px;
        }
      }
    }
  }
}
</style>
